import { breadcrumb } from './breadcrumb';
import { number } from './number';
import { stats } from './stats';

export const phone_number = {
  breadcrumb,
  number,
  stats
};
